import React from 'react';
import '../styles/Header.css';
import logo from '../assets/header-logo2.svg';

const Header: React.FC = () => {
    return (
        <header className="header">
            <div className="header-logo-container">
                <img src={logo} alt="Logo" className="header-logo" />
            </div>
            <nav>
            </nav>
        </header>
    );
};

export default Header;





